import type { ContactFormContent } from '@/components/ContactForm'
import {
  BAND_FIELDS_EN,
  BAND_FIELDS_TR,
  BAND_FORM_EN,
  BAND_FORM_TR,
  MESSAGE_FIELD_EN,
  MESSAGE_FIELD_TR,
} from './bandForm'

/**
 * The Solutions hub's own form.
 *
 * Asked for on 2026-08-31: the three solutions on the cards above the form
 * should be tickable inside it, at least one of them, *"aynı partner program
 * formunda yaptığımız gibi"*. So this is built exactly as `partnerForm.ts` is —
 * the closing band's form with one `checkboxes` field added, rather than a
 * second form written out, so the name, email, company, country and industry
 * questions stay in one place.
 *
 * `required: true` on a checkbox group means **at least one box**, which
 * `ContactForm` enforces itself in both directions (React where the page
 * hydrates, `SUBMIT_JS` where it does not) — no browser does it natively.
 *
 * The option labels are the card titles from the section above, verbatim and in
 * English in both locales' English form; the Turkish page names them the way its
 * own cards do.
 *
 * Because this page now carries a form of its own, it opts out of the shared
 * closing band in `app/Layout.tsx` — otherwise the page would end on two forms
 * and two `id="contact"` in one document.
 */
const SOLUTIONS_EN = ['Strategy Consulting', 'Transformation Management', 'Enterprise AI Solutions']

const SOLUTIONS_TR = ['Strateji Danışmanlığı', 'Dönüşüm Yönetimi', 'Kurumsal Yapay Zeka Çözümleri']

export const SOLUTIONS_FORM_EN: ContactFormContent = {
  ...BAND_FORM_EN,
  fields: [
    ...BAND_FIELDS_EN,
    {
      name: 'solution',
      label: 'Which solution are you interested in? (Choose one or more)',
      type: 'checkboxes',
      required: true,
      options: SOLUTIONS_EN,
    },
    MESSAGE_FIELD_EN,
  ],
}

export const SOLUTIONS_FORM_TR: ContactFormContent = {
  ...BAND_FORM_TR,
  fields: [
    ...BAND_FIELDS_TR,
    {
      name: 'solution',
      label: 'Hangi çözümle ilgileniyorsunuz? (Birden fazla seçebilirsiniz)',
      type: 'checkboxes',
      required: true,
      options: SOLUTIONS_TR,
    },
    MESSAGE_FIELD_TR,
  ],
}
